import { useState } from "react";
import {
  Box,
  UnorderedList,
  ListItem,
  Radio,
  IconButton,
  RadioGroup,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import "./Tree.scss";

export const RadioTree = ({ treeData, onNodeSelect }) => {
  const [selectedNodeId, setSelectedNodeId] = useState(null);

  const handleNodeSelect = (nodeId) => {
    const root_tree = treeData.find((td) =>
      td.children.find((c) => c.id === nodeId)
    );
    setSelectedNodeId(nodeId);
    onNodeSelect(root_tree.id, nodeId);
  };

  return (
    <UnorderedList className="main-tree-component" styleType="none" ml={0}>
      <RadioGroup onChange={handleNodeSelect}>
        {treeData.map((node) => (
          <TreeNode
            key={node.id}
            id={node.id}
            label={node.label}
            children={node.children}
            selectedNodeId={selectedNodeId}
          />
        ))}
      </RadioGroup>
    </UnorderedList>
  );
};

const TreeNode = ({ id, label, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <ListItem onClick={handleToggle}>
      {children.length > 0 ? (
        <Box as="span">
          <IconButton
            icon={isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            variant="ghost"
            size="sm"
            onClick={handleToggle}
            _hover={{
              bg: "transparent",
              border: "none",
            }}
            _active={{
              bg: "transparent",
              border: "none",
            }}
            mr={2}
          />
          {label}
        </Box>
      ) : (
        <Radio value={id}>{label}</Radio>
      )}
      {isExpanded && children.length > 0 && (
        <UnorderedList className="tree-component">
          {children.map((child) => (
            <TreeNode
              key={child.id}
              id={child.id}
              label={child.label}
              children={child.children}
            />
          ))}
        </UnorderedList>
      )}
    </ListItem>
  );
};
